
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
export default {
  name: "RecapScanOkForToken",
   data () {
    return {
      token:null,
      callbackUrl:null,
      callbackLibelle:null,
      doccli_id:null,

    }
  },
  mounted: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callbackUrl;  
    this.callbackLibelle = this.$root.callbackLibelle;
    this.doccli_id = this.$globalService.getSessionSouscription().doccli_id;
    var access_token = localStorage.getItem('access_token');
    var user = sessionStorage.getItem('user');
    this.$root.logoutToken();
    localStorage.setItem("access_token",access_token);   
    sessionStorage.setItem('user',user);
    this.sendResponseCallBack();
    //this.showDossier();
  },
  updated: function () {
    setTimeout(()=>{
      this.callback();
      //alert(0);
   },10000);
  },

  methods: {
    setScanFinish:function(){
      
      this.loading = true;
      doccliService.setScanFinish(this.doccli_id).then(res => {
        console.log(res);
           this.loading = false;
        
      })
      
    },
    sendResponseCallBack:function(){
      
      this.loading = true;
      doccliService.sendResponseCallBack(this.token).then(res => {
        
           this.loading = false;
         if (res) {
            if (res.err == "error") {
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        })
       .catch((error) => {
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
            position: "bottom-right",
            timeout: 5000,
          });
          return error;
        });

      
    },
    callback(){
      if(this.callbackUrl)
        window.location.href=this.callbackUrl;
    }
  }
}